import { ErrorResponse, fetchAPI } from '@quickbit/backoffice-core-frontend';
import { useMutation } from '@tanstack/react-query';

const queryKeys = {
  all: () => ['transactionManualReview.all'] as const,
  approve: (transactionId: string) =>
    [...queryKeys.all(), 'approve', transactionId] as const,
  reject: (transactionId: string) =>
    [...queryKeys.all(), 'reject', transactionId] as const,
};

export const useApproveManualReviewTransaction = (
  transactionId: string,
  onApprove?: () => void
) => {
  const approveTransaction = async () => {
    await fetchAPI(`v1/transactions/${transactionId}/manual-review/approve`, {
      method: 'POST',
    });
    onApprove && onApprove();
    return undefined;
  };

  return useMutation<undefined, ErrorResponse>({
    mutationKey: [...queryKeys.approve(transactionId)],
    mutationFn: approveTransaction,
  });
};

export const useRejectManualReviewTransaction = (
  transactionId: string,
  onReject?: () => void
) => {
  const rejectTransaction = async () => {
    await fetchAPI(`v1/transactions/${transactionId}/manual-review/reject`, {
      method: 'POST',
    });
    onReject && onReject();
    return undefined;
  };

  return useMutation<undefined, ErrorResponse>({
    mutationKey: [...queryKeys.reject(transactionId)],
    mutationFn: rejectTransaction,
  });
};
